import { render, staticRenderFns } from "./RowSpan.vue?vue&type=template&id=5a97cc5d&scoped=true&"
import script from "./RowSpan.vue?vue&type=script&lang=js&"
export * from "./RowSpan.vue?vue&type=script&lang=js&"
import style0 from "./RowSpan.vue?vue&type=style&index=0&id=5a97cc5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a97cc5d",
  null
  
)

export default component.exports